"use client";
import Footer, { type Footer_T } from "@areahub/ui/marketing/footer/footer";

export default function GlobalFooter(props: Footer_T) {
  return <Footer {...props} />;
}
